import React, {useContext, useState, useRef, useEffect} from 'react'
import UserContext from '../context/UserContext'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { BsFillEyeFill, BsFillEyeSlashFill, BsExclamationTriangle } from "react-icons/bs"
import styles from './Login.module.css'
import ConfirmDialog from './ConfirmDialog'
import { trackPromise } from 'react-promise-tracker'
import { appVersion } from '../config';



function Login(props) {
    // console.log("Login")
    
    const userCtx = useContext(UserContext)
    const [error, setError] = useState('')
    const [enteredUsername, setEnteredUsername] = useState('')
    const [enteredPassword, setEnteredPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [confirmDialogParams, setConfirmDialogParams] = useState({show:false})
    const [authCallback, setAuthCallback] = useState({ processing: false, error: null })

    const userid = useRef()
    const password = useRef()

    const baseURL = process.env.REACT_APP_MODE === "PROD" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST

    const queryString = window.location.search;
    // console.log("Login entering: userCtx.isLoggedIn, queryString, window.location", userCtx.isLoggedIn, queryString, window.location)
    

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    }


    const userChange = (event) => {
        setEnteredUsername(event.target.value)
        setError('')
    }

    const passwordChange = (event) => {
        setEnteredPassword(event.target.value)
        setError('')
    }

    // returns object {last:xx, first:xx, middle:xx}
    const nameSplit = (fullName) => {
      const prepositions = '(?:(?:de\\s+la|de\\s+las|de\\s+les|de|di|da|la|le|de|lo|del|dels|do|dos|das|van|von|der)\\s+)';
      const reFirstMiddleLast = new RegExp(`^([\\w-]+)\\s+(?:([\\w-]+)\\s+)?(${prepositions}?[\\w-'']+)$`);
      const reFirstLast = new RegExp(`^([\\w-]+)\\s+(${prepositions}?[\\w-'']+)$`);
      const reLastFirstMiddle = new RegExp(`^(${prepositions}?[\\w-'']+),\\s*([\\w-]+)(?:\\s+([\\w-]+))?$`);

      const theName = {first:'', middle: '', last: ''};

      let matches = fullName.match(reFirstLast) || [];
      if (matches.length === 0) {
        // test first middle Last
        matches = fullName.match(reFirstMiddleLast) || [];
        if (matches.length > 1) {
          // console.log(`${fullName} => First: ${matches[1] || ''}, Middle: ${matches[2] || ''}, Last: ${matches[3] || ''}`)
          return {...theName, first: matches[1] || '', middle: matches[2] || '', last: matches[3] || ''};
        }
        
      } else {
        // console.log(`${fullName} => First: ${matches[1] || ''}, Last: ${matches[2] || ''}`)
        return {...theName, first: matches[1] || '', last: matches[2] || ''};
      }

      // if we are still here, try Lats, First [Middle]
      matches = fullName.match(reLastFirstMiddle) || [];
      if (matches.length >= 4) {
        // console.log(`${fullName} => First: ${matches[2] || ''}, Middle: ${matches[3] || ''}, Last: ${matches[1] || ''}`)
        return {...theName, first: matches[2] || '', middle: matches[3] || '', last: matches[1] || ''};
      } else {
        // console.log(`${fullName} => First: ${matches[2] || ''}, Last: ${matches[1] || ''}`)
        return {...theName, first: matches[2] || '', middle: '', last: matches[1] || ''};
      }



      return theName;
    }


    const getUser = async (uInfo, token, token_type) => {
        // get user details
        // console.log("getUser - uInfo", uInfo);
        const user_me_url = `${baseURL}users/me`
        await fetch(user_me_url, {
            method: 'GET',
            headers: {
                Authorization: `${token_type} ${token}`
            }
        })
        .then((response) => response.json())
        .then(data => {
            // console.log("user", data)
            if (!!data) {
                let last_name = ''
                let first_name = ''

                // if (!!data.full_name) {
                //   // Okta seems sends full name in "first last" format. Try to get format

                //     // first last (ignore middle)
                //     // const reFirstLast = /^([\w-.]+)\s*(.*?)\s*([\w-']+)$/;
                //     // const [fullMatch, first, middle, last] = data.full_name.match(reFirstLast) || [];
                //     // if (!!first && !!last) {
                //     //   last_name = last;
                //     //   first_name = first;
                //     // } else {
                //     //   // last, first middle
                //     //   const reLastFirst = /^([^,]+),\s*(.+)$/;
                //     //   const [fullMatch, last, first] = data.full_name.match(reLastFirst) || [];
                //     //   if (!!first && !!last) {
                //     //     last_name = last;
                //     //     first_name = first;
                //     //   } 
                //     // }

                //     // let names = data.full_name.split(',')
                //     // if (names.length > 0) {
                //     //     last_name = names[0].trim()
                //     // }
                //     // if (names.length > 1) {
                //     //     first_name = names[1].trim()
                //     // }

                //     const theName = nameSplit(data.full_name);
                //     last_name = theName.last;
                //     first_name = theName.first;
                // }

                const uInfo2 = {...uInfo, 
                    is_active: data.is_active || false, 
                    user: data.username || '',
                    // DEBUG >>>>>>>>
                    is_super_user: data.is_superuser || false,
                    // <<<<<<< DEBUG
                    user_name: data.username || '', 
                    full_name: data.full_name || '',
                    id: data.id || '',
                    email: data.email || '',
                    last_name: data.last_name,
                    first_name: data.first_name,
                };
                // console.log("uInfo2", uInfo2)
                userCtx.setUserInfo(uInfo2);
            } else {
                userCtx.setUserInfo(uInfo);
            }
            
        })
        .catch(e => {
            console.log("error getting user details", e)
            setConfirmDialogParams({
                show: true,
                text: ["Please try again.", "If the error persists please contact Support"],
                textClass: 'confirmation-text',
                prompt: "Something went wrong",
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => {
                    setConfirmDialogParams({show: false})
                },
                title: "Error!", //'Please Confirm',
                // title_class: styles['alert-title'],
                title_class: 'alert-title',
                icon: <BsExclamationTriangle />,
                // showConfirm: true,
                confirm_only: true,
            })
        })
    }



    const onLogin = (event) => {
        event.preventDefault();
        // if no user id or/and password or/and year is not selected - cancel submit (return false)
        // const enteredUsername = document.getElementById('username').value
        // const enteredPassword = document.getElementById('password').value

        if (enteredUsername === '' || enteredPassword === '') {
            return false
        } else {
            // remove user domain if entered
            let userId = ''
            if (enteredUsername.includes("\\")) {
                // window.sessionStorage.setItem("user", enteredUsername)
                const backslash = enteredUsername.indexOf('\\')
                userId = enteredUsername.substring(backslash+1)
            } else {
                // window.sessionStorage.setItem("user", `partners\\${enteredUsername}`)
                userId = enteredUsername
            }
            
            // console.log("User ID", userId)
            
            const body = {
                grant_type: 'password',
                username: userId,
                password: enteredPassword
            }


            const params = new URLSearchParams(body);
            const auth_url = `${baseURL}login/access-token`

            const doLogin = async () => {
                await fetch(auth_url, {
                    method: 'POST',
                    body: params,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then((response) => response.json())
                .then(data => {
                    // console.log("Login data", data)
                    if (!!data && !!data.access_token && !!data.token_type ) {
                        setError('')
                        const uInfo = {...userCtx.userInfo, 
                            user: userId || '', 
                            // user_name: data.user.name || '', 
                            // userLastName: data.user.last_name || '',
                            // userFirstName: data.user.first_name || '',
                            isLoggedIn: true, 
                            jwt: data.access_token,
                            token_type: data.token_type,
                        };
    
                        
    
                        // const uInfo2 = getUser(uInfo, data.access_token, data.token_type)
                        // userCtx.setUserInfo(uInfo2);
                        trackPromise(
                            getUser(uInfo, data.access_token, data.token_type)
                            ,'login'
                        )
    
                        setEnteredUsername('')
                        setEnteredPassword('')
                        setShowPassword(false)

                        
                    } else {
                        // not authorized or not authenticated
                        setError('Incorrect Username or Password')
                    }
    
                })
                .catch(e => {
                    console.log("error during authorization", e)
                    setConfirmDialogParams({
                        show: true,
                        text: ["Please try again.", "If the error persists please contact Support"],
                        textClass: 'confirmation-text',
                        prompt: "Something went wrong",
                        prompt_class: 'alert-prompt-red',
                        cancel_button_text: null,
                        confirm_button_text: 'OK',
                        confirm_button_variant: 'primary',
                        onClose: (result) => {
                            setConfirmDialogParams({show: false})
                        },
                        title: null, //'Please Confirm',
                        // title_class: styles['alert-title'],
                        icon: <BsExclamationTriangle />,
                        // showConfirm: true,
                        confirm_only: true,
                    })
                })
            }
            
            trackPromise(
                doLogin(),
                'login'
            )
            
            
        }




    }



    useEffect(() => {
      // console.log("Login useEffect: queryString, window.location", queryString, window.location)
      if (window.location.search != "") {
        const urlParams = new URLSearchParams(window.location.search); 
        const token = urlParams.get('token') || urlParams.get('access_token');
        const tokenType = urlParams.get('token_type') || 'Bearer';
        
        // console.log("Login useEffect: token", token)
        if(!!token) {
          setError('')
          const uInfo = {...userCtx.userInfo, 
              isLoggedIn: true, 
              jwt: token,
              token_type: tokenType,
          };
          trackPromise(
              getUser(uInfo, token, tokenType)
              ,'login'
          )
          // Clear URL params after successful login
          window.history.replaceState({}, document.title, '/');
        }

      }
    },[window.location.search])



    if (userCtx.isLoggedIn) {
        return (<></>)
    }


    return (
        <div className={styles.fullscreen} >
            <Modal size="md" backdrop="static" centered show={true} 
                backdropClassName={styles.white}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5 className={styles['app-name']}>McLean Inventory Portal (v.{appVersion})</h5>
                        <h6 className='mt-3'>Please login to your MGB account</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {process.env.REACT_APP_USE_OKTA_SAML==="true" && queryString===""?
                    <Row>
                        <div className='col'>
                            <Button className='w-100 btn-large fs-5 text' 
                              variant="outline-primary"
                              href={`${baseURL}login/saml/login?forceAuthn=true`}
                            >
                                Login
                            </Button>
                        </div>
                      </Row>
                    :
                    <Form 
                        onSubmit={onLogin}
                        // className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
                    >

                        <Row className='my-3'>      
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="userid">Username</Form.Label>
                                <Form.Control
                                    placeholder='MGB Network User ID'
                                    type='text'
                                    name="userid"
                                    required
                                    ref={userid}
                                    onChange={userChange}
                                    value={enteredUsername}
                                />
                            </Form.Group>
                        </Row>

                        <Row className='my-3'>      
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="password" >Password</Form.Label>
                                <div className="password-input-container">
                                    <Form.Control
                                        placeholder='Password'
                                        //type='password'
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        autoComplete="on"
                                        required
                                        ref={password}
                                        onChange={passwordChange}
                                        value={enteredPassword}
                                    />
                                    <div className="password-toggle" onClick={togglePasswordVisibility}>
                                        {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                    </div>
                                </div>
                            </Form.Group>
                        </Row>
                        {!!error && 
                            <Row>
                                <span className={styles.error}>{error}</span>
                            </Row>
                        }

                        <Row>
                            <div className='col'>
                                <Button className='w-100 btn-large fs-5 text' variant="outline-primary" /*onClick={handleLogin}*/ type="submit">
                                    Login
                                </Button>
                            </div>
                        </Row>

                    </Form>
                    }
                </Modal.Body>
            </Modal>

            {confirmDialogParams.show &&
                <ConfirmDialog 
                    show={confirmDialogParams.show}
                    iconColor='red'
                    iconSize='2rem'
                    icon={confirmDialogParams.icon}
                    title={confirmDialogParams.title}
                    title_class={confirmDialogParams.title_class}
                    text={confirmDialogParams.text}
                    textClass={confirmDialogParams.textClass}
                    prompt={confirmDialogParams.prompt}
                    prompt_class={confirmDialogParams?.prompt_class}
                    cancel_button_text={confirmDialogParams.cancel_button_text}
                    confirm_button_text={confirmDialogParams.confirm_button_text}
                    confirm_button_variant={confirmDialogParams.confirm_button_variant}
                    onClose={confirmDialogParams.onClose}
                    confirm_only={true}
                />
            }
        </div>
    )
}

export default Login

